export enum ResultType {
  STUDY_MATCH = 'STUDY_MATCH',
  HLF = 'HLF',
  QUALIFIED_RESULTS_PAGE = 'QUALIFIED_RESULTS_PAGE',
  CUSTOM_RESULTS_PAGE = 'CUSTOM_RESULTS_PAGE',
  OFFERINGS = 'OFFERINGS',
  DASHBOARD = 'DASHBOARD',
}

export enum QuestionType {
  TEXT = 'TEXT',
  SELECT = 'SELECT',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  RADIO_CHOICE = 'RADIO_CHOICE',
  CHECKBOX = 'CHECKBOX',
  TOGGLE = 'TOGGLE',
  DYNAMIC_SINGLE_CHOICE = 'DYNAMIC_SINGLE_CHOICE',
  DYNAMIC_MULTIPLE_CHOICE = 'DYNAMIC_MULTIPLE_CHOICE',
}

export enum QuestionOrientationType {
  ROW = 'ROW',
  COLUMN = 'COLUMN',
}

export enum StepType {
  QUESTION = 'QUESTION',
  COMPONENT = 'COMPONENT',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  MULTI_QUESTION = 'MULTI_QUESTION',
  DCS = 'DCS',
  RESULT = 'RESULT',
  BANNER_CTA = 'BANNER_CTA',
}

export enum Operator {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  CONTAINS = 'CONTAINS',
  CONTAINS_ANY = 'CONTAINS_ANY',
  // Visibility/binding `when` gates only. Holds for an unresolved value, so it
  // works as a "show unless" default. Not implemented by option branching
  // (`getNextStep`), where it falls through to `default: return false`.
  NOT_CONTAINS_ANY = 'NOT_CONTAINS_ANY',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
}

export enum ConditionType {
  DEFAULT = 'DEFAULT',
  GROUP_SELECTED = 'GROUP_SELECTED',
  OPTION_SELECTED = 'OPTION_SELECTED',
  COMBINATION_SELECTED = 'COMBINATION_SELECTED',
}

export enum LogicType {
  NEXT_STEP = 'NEXT_STEP',
  RESULT = 'RESULT',
}

export enum ComponentType {
  CAPPEX = 'CAPPEX',
  SALARY_CALCULATOR = 'SALARY_CALCULATOR',
  DUAL_CTA_EL_MARKETPLACE = 'DUAL_CTA_EL_MARKETPLACE',
  EDITORIAL_LISTINGS = 'EDITORIAL_LISTINGS',
  CAREER_PATHWAY = 'CAREER_PATHWAY',
  DEGREE_LENGTH = 'DEGREE_LENGTH',
  BANNER_CTA = 'BANNER_CTA',
}

export enum ActionType {
  SET_STEPS = 'SET_STEPS',
  SET_CURRENT_STEP = 'SET_CURRENT_STEP',
  SET_CURRENT_STEP_INDEX = 'SET_CURRENT_STEP_INDEX',
  SET_NAVIGATION_HISTORY = 'SET_NAVIGATION_HISTORY',
  ADD_TO_NAVIGATION_HISTORY = 'ADD_TO_NAVIGATION_HISTORY',
  GO_BACK_IN_HISTORY = 'GO_BACK_IN_HISTORY',
  UPDATE_FLOW_STATE = 'UPDATE_FLOW_STATE',
  SET_FLOW_STATE = 'SET_FLOW_STATE',
  SET_OPEN_MODAL = 'SET_OPEN_MODAL',
  SET_ACCEPT_TCPA = 'SET_ACCEPT_TCPA',
  SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS',
  CLEAR_VALIDATION_ERRORS = 'CLEAR_VALIDATION_ERRORS',
  SET_FORM_STARTED_FIRED = 'SET_FORM_STARTED_FIRED',
  JUMP_TO_STEP = 'JUMP_TO_STEP',
  SET_IS_SUBMITTING = 'SET_IS_SUBMITTING',
  SET_SUBMISSION_ERROR = 'SET_SUBMISSION_ERROR',
  SET_POPUP_BLOCKED = 'SET_POPUP_BLOCKED',
  RESET_FLOW = 'RESET_FLOW',
}

export enum EventingLocation {
  EMBEDDED_RECOMMENDER = 'dexp-embedded-recommender',
  POPUP = 'dexp-pop-up-recommender',
  PAGE = 'dexp-results-page',
  UNDERGRAD_THANK_YOU_PAGE = 'dexp-undergrad-thank-you-page',
  RECOMMENDER_GRAD_THANK_YOU_PAGE = 'dexp-recommender-grad-thank-you-page',
  READY_TO_GO_THANK_YOU_PAGE = 'dexp-ready-to-go-thank-you-page',
  THANK_YOU_PAGE = 'dexp-thank-you-page',
  SPOTLIGHT_POPUP = 'dexp-spotlight-popup',
  CONVERSION_DRAWER = 'dexp-conversion-drawer',
  PAGE_POPUP = 'dexp-results-page-pop-up',
}

export enum PositionEngine {
  ALGOLIA = 'algolia',
}

// Lead-related enums (LevelOfEducation, AcademicAwards, LicenseTypes, etc.)
// are defined in ./leadDelivery.ts and re-exported via ./index.ts
